// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expression-builder {
  margin-top: 0.5rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.expression-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}
.expression-toggle input[type=checkbox] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.expression-toggle label {
  margin-left: 0.5rem;
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9em;
  color: #495057;
}

.expression-form {
  margin-top: 0.75rem;
}

.function-search {
  margin-bottom: 0.5rem;
}
.function-search input {
  font-size: 0.85em;
}

.function-select {
  margin-bottom: 0.75rem;
}
.function-select label {
  display: block;
  font-weight: 500;
  font-size: 0.85em;
  margin-bottom: 0.25rem;
  color: #495057;
}
.function-select select {
  font-size: 0.9em;
}
.function-select optgroup {
  font-weight: 600;
  color: #17a2b8;
}

.function-description {
  font-size: 0.8em;
  color: #6c757d;
  font-style: italic;
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  background-color: #e9ecef;
  border-radius: 3px;
}
.function-description i {
  color: #17a2b8;
  margin-right: 0.25rem;
}

.parameter-form .param-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}
.parameter-form .param-row .param-label {
  min-width: 110px;
  max-width: 110px;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.85em;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.parameter-form .param-row .param-label .required-indicator {
  color: #dc3545;
  margin-left: 2px;
}
.parameter-form .param-row .input-group {
  flex: 1;
}
.parameter-form .param-row input, .parameter-form .param-row select {
  flex: 1;
  font-size: 0.85em;
}
.parameter-form .param-row .insert-path-btn {
  font-size: 0.75em;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}
.parameter-form .param-row .insert-path-btn i {
  margin-right: 2px;
}

.expression-preview {
  margin-top: 0.75rem;
  padding: 0.5rem 0.75rem;
  background-color: #e9ecef;
  border-radius: 4px;
  border-left: 3px solid #17a2b8;
}
.expression-preview label {
  display: block;
  font-size: 0.75em;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.expression-preview code {
  display: block;
  font-size: 0.85em;
  word-break: break-all;
  color: #495057;
  background: transparent;
  padding: 0;
}

.validation-message {
  margin-top: 0.5rem;
  font-size: 0.8em;
}
.validation-message i {
  margin-right: 0.25rem;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.input-group-append .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/add-mapping-dialog/expression-builder/expression-builder.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACJ;AAEE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,qBAAA;AADF;AAGE;EACE,iBAAA;AADJ;;AAKA;EACE,sBAAA;AAFF;AAIE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,gBAAA;EACA,cAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AALF;AAOE;EACE,cAAA;EACA,qBAAA;AALJ;;AAUE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AAPJ;AASI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPN;AASM;EACE,cAAA;EACA,gBAAA;AAPR;AAWI;EACE,OAAA;AATN;AAYI;EACE,OAAA;EACA,iBAAA;AAVN;AAaI;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;AAXN;AAaM;EACE,iBAAA;AAXR;;AAiBA;EACE,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AAdF;AAgBE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AAdJ;AAiBE;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;AAfJ;;AAmBA;EACE,kBAAA;EACA,gBAAA;AAhBF;AAkBE;EACE,qBAAA;AAhBJ;;AAqBA;EACE,kCAAA;EACA,uBAAA;EACA,mBAAA;AAlBF;;AAuBE;EACE,yBAAA;EACA,4BAAA;AApBJ","sourcesContent":[".expression-builder {\r\n  margin-top: 0.5rem;\r\n  padding: 0.75rem;\r\n  background-color: #f8f9fa;\r\n  border-radius: 4px;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.expression-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  border-bottom: 1px solid #e9ecef;\r\n\r\n  input[type=\"checkbox\"] {\r\n    width: 16px;\r\n    height: 16px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  label {\r\n    margin-left: 0.5rem;\r\n    margin-bottom: 0;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    font-size: 0.9em;\r\n    color: #495057;\r\n  }\r\n}\r\n\r\n.expression-form {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.function-search {\r\n  margin-bottom: 0.5rem;\r\n\r\n  input {\r\n    font-size: 0.85em;\r\n  }\r\n}\r\n\r\n.function-select {\r\n  margin-bottom: 0.75rem;\r\n\r\n  label {\r\n    display: block;\r\n    font-weight: 500;\r\n    font-size: 0.85em;\r\n    margin-bottom: 0.25rem;\r\n    color: #495057;\r\n  }\r\n\r\n  select {\r\n    font-size: 0.9em;\r\n  }\r\n\r\n  optgroup {\r\n    font-weight: 600;\r\n    color: #17a2b8;\r\n  }\r\n}\r\n\r\n.function-description {\r\n  font-size: 0.8em;\r\n  color: #6c757d;\r\n  font-style: italic;\r\n  margin-bottom: 0.75rem;\r\n  padding: 0.5rem;\r\n  background-color: #e9ecef;\r\n  border-radius: 3px;\r\n\r\n  i {\r\n    color: #17a2b8;\r\n    margin-right: 0.25rem;\r\n  }\r\n}\r\n\r\n.parameter-form {\r\n  .param-row {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 0.5rem;\r\n    gap: 0.5rem;\r\n\r\n    .param-label {\r\n      min-width: 110px;\r\n      max-width: 110px;\r\n      margin-bottom: 0;\r\n      font-weight: 500;\r\n      font-size: 0.85em;\r\n      color: #495057;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n\r\n      .required-indicator {\r\n        color: #dc3545;\r\n        margin-left: 2px;\r\n      }\r\n    }\r\n\r\n    .input-group {\r\n      flex: 1;\r\n    }\r\n\r\n    input, select {\r\n      flex: 1;\r\n      font-size: 0.85em;\r\n    }\r\n\r\n    .insert-path-btn {\r\n      font-size: 0.75em;\r\n      padding: 0.25rem 0.5rem;\r\n      white-space: nowrap;\r\n\r\n      i {\r\n        margin-right: 2px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.expression-preview {\r\n  margin-top: 0.75rem;\r\n  padding: 0.5rem 0.75rem;\r\n  background-color: #e9ecef;\r\n  border-radius: 4px;\r\n  border-left: 3px solid #17a2b8;\r\n\r\n  label {\r\n    display: block;\r\n    font-size: 0.75em;\r\n    font-weight: 600;\r\n    color: #6c757d;\r\n    margin-bottom: 0.25rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n  }\r\n\r\n  code {\r\n    display: block;\r\n    font-size: 0.85em;\r\n    word-break: break-all;\r\n    color: #495057;\r\n    background: transparent;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.validation-message {\r\n  margin-top: 0.5rem;\r\n  font-size: 0.8em;\r\n\r\n  i {\r\n    margin-right: 0.25rem;\r\n  }\r\n}\r\n\r\n// Form control sizing\r\n.form-control-sm {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n// Input group adjustments\r\n.input-group-append {\r\n  .btn {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
